import { ref } from "vue";

const page = ref("GeneralPage");

const changePage = (newPage) => {
  page.value = newPage
}

export { page, changePage }
